import React from 'react';
import PropTypes from 'prop-types';

export const PDF = ({ width, height, ...props }) => (
  <svg
    data-icon='pdf'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M9 12.5h1v-2h1c.283 0 .52-.096.713-.287A.968.968 0 0 0 12 9.5v-1a.967.967 0 0 0-.287-.713A.968.968 0 0 0 11 7.5H9v5Zm1-3v-1h1v1h-1Zm3 3h2c.283 0 .52-.096.713-.287A.968.968 0 0 0 16 11.5v-3a.967.967 0 0 0-.287-.713A.968.968 0 0 0 15 7.5h-2v5Zm1-1v-3h1v3h-1Zm3 1h1v-2h1v-1h-1v-1h1v-1h-2v5ZM8 18c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 6 16V4c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 8 2h12c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 18H8Zm0-2h12V4H8v12Zm-4 6c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20V6h2v14h14v2H4Z'
    />
  </svg>
);

PDF.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

PDF.defaultProps = {
  width: 24,
  height: 24,
};
